import { render } from "./AddQuestion.vue?vue&type=template&id=673df9e2&scoped=true"
import script from "./AddQuestion.vue?vue&type=script&lang=js"
export * from "./AddQuestion.vue?vue&type=script&lang=js"

import "./AddQuestion.vue?vue&type=style&index=0&id=673df9e2&scoped=true&lang=css"

import exportComponent from "E:\\VSProjects\\HTML\\quickcalculationpractice\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673df9e2"]])

export default __exports__